//Remove signal in the meantime to avoid state updates and state
//responses from wining a race
import api from "./axios";

const ActiveProviderApi = {
  //async getActiveProviders(_patientId, { page = 0, size = 20, signal } = {}) {
  async getActiveProviders(_patientId, { page = 0, size = 20 } = {}) {
    const url = "/api/v1/patients/me/active-providers";

    const res = await api.get(url, {
      params: { page, size },
      //signal,
    });

    return res.data;
  },
};

export default ActiveProviderApi;
